export const AutoIssuedCouponType = {
    SIGN_UP: "신규가입",
    BIRTHDAY: "생일쿠폰",
    SPECIFIC_DATE: "날짜지정",
} as const;
